import { useViewMode } from '@/lib/view-mode-context';
import { useWhoPayWho } from '@/hooks/use-who-pay-who';
import { UiStrategy } from "@/ui/UiStrategy";
import { WhoPayWhoClassicView } from "@/ui/v1/WhoPayWhoClassicView";
import { WhoPayWhoModernView } from "@/ui/v2/WhoPayWhoModernView";
import { WhoPayWhoNeonView } from "@/ui/v3/WhoPayWhoNeonView";

export default function WhoPayWho() {
  const { targetUserId, isReadOnly } = useViewMode();
  const { data, isLoading } = useWhoPayWho(targetUserId);

  if (isLoading && !data) {
    return (
      <div className="py-6 flex justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    );
  }

  const props = {
    playerTotals: data?.playerTotals || [],
    transactions: data?.transactions || [],
    isLoading,
    targetUserId,
    isReadOnly
  };

  return (
    <UiStrategy
      classic={<WhoPayWhoClassicView {...props} />}
      modern={<WhoPayWhoModernView {...props} />}
      neon={<WhoPayWhoNeonView {...props} />}
    />
  );
}
